export { MessageTypeEnum, MESSAGE_TYPE_ENUM_RECORD } from '@umss/shared/utils';
